module.exports = __webpack_public_path__ + "img/tip.f24d28d8.png";